module.exports = __webpack_public_path__ + "static/cube1-55fc8567e5d320ca542049b53fbeb186.svg";